import { render, staticRenderFns } from "./Ecran.vue?vue&type=template&id=19cfc84d&"
import script from "./Ecran.vue?vue&type=script&lang=js&"
export * from "./Ecran.vue?vue&type=script&lang=js&"
import style0 from "./Ecran.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports